import { render, staticRenderFns } from "./inputSubmit.vue?vue&type=template&id=48e431a7"
import script from "./inputSubmit.vue?vue&type=script&lang=js"
export * from "./inputSubmit.vue?vue&type=script&lang=js"
import style0 from "./inputSubmit.vue?vue&type=style&index=0&id=48e431a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports